export const BUSINESS_CASE_SIGNAL_EVIDENCE_OMISSIONS = [
  'timelineTruncated',
  'plannedActivitiesTruncated',
  'otherUsersTasks',
  'checklistUnavailable',
  'paymentEvidenceIncomplete',
  'offerEvidenceIncomplete',
  'enrichment',
] as const;

export type BusinessCaseSignalEvidenceOmission =
  (typeof BUSINESS_CASE_SIGNAL_EVIDENCE_OMISSIONS)[number];
